<div class="container admin-page-container">

  <div class="row" style="align-items: center;">

    <div class="col" align="left">
      <h1 i18n class="blue-trip-heading">Admin Panel</h1>
    </div>

    <div class="col" align="right">
      <app-menu> </app-menu>
    </div>

  </div>

  <mat-divider></mat-divider>

  @if (true) {
    <div>
      <mat-chip-listbox #listbox (change)="chipMenuSelectionChange(listbox, $event)" hideSingleSelectionIndicator="true">
        <mat-chip-option #users [selected]="showUserList" value="users">View users and manage data</mat-chip-option>
        <mat-chip-option #logbooks [selected]="showLogbooks" value="logbooks">Manage Logbooks and mappings for FINs/VRNs and VRNS/Logbooks</mat-chip-option>
      </mat-chip-listbox>
      <mat-divider></mat-divider>
    </div>
  }

  @if (showUserList) {
    <div style="margin-top: 30px">
      <div class="row" style="align-items: baseline;">
        <div class="col-6">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Filter users...</mat-label>
            <input matInput (keyup)="filterUsers($event)" #input>
          </mat-form-field>
        </div>
        <div class="col-3">
          <button mat-flat-button [style.background-color]="selectedUser ? 'coral' : 'lightgrey'"
            style="color: white; width: 100%;" [disabled]="!selectedUser" (click)="replicateUserData()">
            Replicate User's data
            @if (replicating) {
              <mat-progress-bar mode="buffer"></mat-progress-bar>
            }
          </button>
        </div>
        <div class="col-3">
          <button mat-flat-button [style.background-color]="selectedUser ? 'coral' : 'lightgrey'"
            style="color: white; width: 100%;" [disabled]="!selectedUser" (click)="openTripsDialog()">
            Add Confirmation Number
          </button>
        </div>
      </div>

      <table mat-table [dataSource]="userList" matSort #userSort="matSort" matSortActive="name"
        matSortDirection="asc" matSortDisableClear class="mat-elevation-z8" style="margin-top: 1px;">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let user"> {{user.name}} </td>
        </ng-container>

        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> FIN </th>
          <td mat-cell *matCellDef="let user"> {{user.fin}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let user"> {{user.email}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedUserColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedUserColumns" (click)="selectedUser = row"
          [style.background-color]="selectedUser === row ? 'lightblue' : 'white'"></tr>
      </table>
    </div>
  }

  <div [hidden]="!showLogbooks" style="margin-top: 30px;">

    <!-- Season Logbook Deactivation -->
    <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
      <mat-toolbar class="admin-toolbar">
        <h5 class="admin-toolbar-title">Season Logbook Deactivation</h5>
      </mat-toolbar>
    </div>

    <div class="season-controls">

      <div class="season-left">
        <mat-form-field appearance="outline" class="season-year-field">
          <mat-label>Season Year</mat-label>
          <input
            matInput
            type="number"
            [value]="deactivateSeasonYear"
            (input)="onDeactivateYearChange($event)" />
        </mat-form-field>
      </div>

      <div class="season-middle">
        @for (gear of deactivationGearOptions; track gear) {
          <mat-checkbox
            [checked]="deactivationGearSelected[gear]"
            (change)="toggleDeactivationGear(gear, $event.checked)">
            {{ gear }}
          </mat-checkbox>
        }
      </div>

      <div class="season-right">
        <button
          mat-flat-button
          class="btn-coral"
          type="button"
          [disabled]="dryRunBusy || deactivateBusy"
          (click)="runDeactivationDryRun()">
          @if (dryRunBusy) {
            <mat-progress-spinner mode="indeterminate" diameter="18" style="margin-right:8px;"></mat-progress-spinner>
          } @else {
            Dry Run
          }
        </button>

        <button
          mat-flat-button
          class="btn-coral"
          type="button"
          [disabled]="deactivateBusy || dryRunBusy || !dryRunResult || !hasAnyDeactivationGearSelected"
          (click)="runDeactivation()">
          @if (deactivateBusy) {
            <mat-progress-spinner mode="indeterminate" diameter="18" style="margin-right:8px;"></mat-progress-spinner>
          } @else {
            Deactivate
          }
          
        </button>
      </div>

    </div>

    @if (dryRunResult) {
      <div class="row" style="margin-bottom: 15px;">
        <div class="col">
          <div style="padding: 10px; border: 1px solid #ddd; border-radius: 10px;">
            <b>Dry Run Summary</b><br />
            Season: {{dryRunResult.year}}<br />
            Gears: {{dryRunResult.gearNames.join(', ')}}<br />
            Scanned user docs: {{dryRunResult.scannedUserDocs}}<br />
            User docs to update: {{dryRunResult.updatedUserDocs}}<br />
            User logbooks to deactivate: {{dryRunResult.updatedUserLogbooks}}<br />
            Backfilled seasonYear: {{dryRunResult.backfilledSeasonYear}}<br />
            Backfilled isActive: {{dryRunResult.backfilledIsActive}}<br />
          </div>
        </div>
      </div>
    }

    <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
      <mat-toolbar style="background-color: #004165; justify-content: space-between; border-radius: 20px;">
        <h5 style="color: white; font-weight: bold; margin-bottom: 0px;">Current Logbooks</h5>
        <button mat-icon-button (click)="addLogbookDialog(logbookData.data.length)" [disabled]="filterActive"
          [style.background-color]="filterActive ? 'lightgrey' : 'coral'" matTooltip="Add Logbook" class="add-logbook-btn">
          <mat-icon>add</mat-icon>
        </button>
      </mat-toolbar>
    </div>

    <div class="logbook-filter-row">
      <mat-form-field appearance="outline" class="logbook-search-field">
        <mat-label>Search logbooks..</mat-label>
        <input matInput (keyup)="filterLogbooks($event)">
      </mat-form-field>

      <mat-form-field appearance="outline" class="logbook-year-field">
        <mat-label>Season Year</mat-label>
        <mat-select [value]="selectedLogbookYear" (selectionChange)="onLogbookYearChange($event.value)">
          <mat-option value="all">All Years</mat-option>
          @for (year of logbookYears; track year) {
            <mat-option [value]="year">{{ year }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <table mat-table #logbookTable [dataSource]="logbookData" matSort matSortDisableClear class="mat-elevation-z8">

      <ng-container matColumnDef="gearname">
        <th mat-header-cell *matHeaderCellDef>Gear Name</th>
        <td mat-cell *matCellDef="let logbook"> {{logbook.gearName}} </td>
      </ng-container>

      <ng-container matColumnDef="logbook#">
        <th mat-header-cell *matHeaderCellDef>Logbook #</th>
        <td mat-cell *matCellDef="let logbook"> {{logbook.logbookID}} </td>
      </ng-container>

      <ng-container matColumnDef="vname">
        <th mat-header-cell *matHeaderCellDef>Linked Vessel</th>
        <td mat-cell *matCellDef="let logbook"> {{logbook.vessel.vesselName}} </td>
      </ng-container>

      <ng-container matColumnDef="vrn">
        <th mat-header-cell *matHeaderCellDef>VRN</th>
        <td mat-cell *matCellDef="let logbook"> {{logbook.vessel.vesselRegistrationNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="seasonYear">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Season Year</th>
        <td mat-cell *matCellDef="let logbook"> {{logbook.seasonYear}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="allLogbooksColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: allLogbooksColumns; let i=index"
        (click)="addLogbookDialog(i + logbookPaginator.pageIndex*logbookPaginator.pageSize)"></tr>
    </table>

    <mat-paginator #logbookPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    <mat-toolbar style="background-color: #004165; justify-content: space-between; margin-top: 15px; border-radius: 20px;">
      <h5 style="color:white; font-weight: bold; margin-bottom: 0px;">FIN/VRN and VRN/Logbook Mappings</h5>
    </mat-toolbar>

    <div style="display: flex; justify-content: space-between; margin-top: 10px;">
      <button mat-flat-button (click)="addEditMapping('fin-vrn', true)" [disabled]="filterActive"
        [style.background-color]="filterActive ? 'lightgrey' : 'coral'" style="color: white; border-radius: 15px;">
        Add FIN-VRN mapping
      </button>
      <button mat-flat-button (click)="addEditMapping('vrn-lb', true)" [disabled]="filterActive"
        [style.background-color]="filterActive ? 'lightgrey' : 'coral'" style="color: white; border-radius: 15px;">
        Add VRN-Logbook mapping
      </button>
    </div>

    <div style="display: flex; justify-content: space-between; margin-top: 10px;">

      <table mat-table #finVrnTable [dataSource]="finVrnMappingData" class="mat-elevation-z8"
        style="min-width: min-content; flex-grow: 0.4; height:fit-content;">

        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef>FIN</th>
          <td mat-cell *matCellDef="let mapping"> {{mapping.fin}} </td>
        </ng-container>

        <ng-container matColumnDef="vrn">
          <th mat-header-cell *matHeaderCellDef>VRN</th>
          <td mat-cell *matCellDef="let mapping"> {{mapping.vrn}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedVrnFin; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedVrnFin; let i=index"
          (click)="addEditMapping('fin-vrn', false, i, row)"></tr>
      </table>

      <table mat-table #vrnLbTable [dataSource]="vrnLogbookMappingData" class="mat-elevation-z8"
        style="min-width: min-content; flex-grow: 0.4; height: fit-content;">

        <ng-container matColumnDef="vrn">
          <th mat-header-cell *matHeaderCellDef> VRN </th>
          <td mat-cell *matCellDef="let mapping"> {{mapping.vrn}} </td>
        </ng-container>

        <ng-container matColumnDef="logbook#">
          <th mat-header-cell *matHeaderCellDef> Logbook # </th>
          <td mat-cell *matCellDef="let mapping"> {{mapping.logbookNum}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedVrnLogbooks; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedVrnLogbooks; let i=index;"
          (click)="addEditMapping('vrn-lb', false, i, row)"></tr>
      </table>

    </div>

  </div>

</div>
